// extracted by mini-css-extract-plugin
module.exports = {"list":"list__V73-R","listItem":"listItem__1OGwW","active":"active__2e9mh"};